import { format } from "date-fns";

/**
 * Word dates for statement / deposit PDF chrome (Generated on, period range).
 * Example: Aug 29th, 2026. Transaction table rows stay numeric (dd/MM/yyyy).
 */
export function formatPdfDisplayDate(date: Date): string {
  return format(date, "MMM do, yyyy");
}
